export const PERMISSION = [
    "user.read",
    "openid",
    "profile",
    "Calendars.Read.Shared",
    "Directory.Read.All",
  ]